import React from 'react'
import './TitleBar.css'

const TitleBar = ({
    title,
    type = 'light'
}) => {

    return (
        <>
            <section className={type === 'dark' ? "title-bar dark" : "title-bar"}>
                <div className="tb-name">
                    <span>{title}</span>
                </div>
                <div className="tb-bar"></div>
            </section>
        </>
    )
}

export default TitleBar